<template>
  <div>
    <navbar 
      ref="navbar"
      position="fixed"
      menu-classes="ml-auto">
      <template>
        <router-link 
          class="navbar-brand" 
          to="/">
          <img 
            src="img/logo-prefix.png"
            height="56">
          <div 
            id="logoText" 
            :style="`fontSize: ${fontSize}`">{{ options.logoText }}</div>
        </router-link>
      </template>
      <template slot="navbar-menu">
        <li class="nav-item">
          <router-link 
            v-if="showReserve"
            class="nav-link" 
            to="/offers">
            <i class="bx bxs-car mr-1"/>
            <p>Reserve Now</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link 
            class="nav-link" 
            to="/privacy-policy">
            <i class="bx bx-shield mr-1"/>
            <p>Privacy Policy</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link 
            class="nav-link" 
            to="/terms-of-service">
            <i class="bx bxs-file mr-1"/>
            <p>Terms of Service</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link 
            class="nav-link" 
            to="/faq">
            <i class="bx bx-message-square"/> 
            <p>FAQ</p>
          </router-link>
        </li>
        <li 
          v-if="!accessToken" 
          class="nav-item">
          <a 
            class="nav-link" 
            href="#"
            @click.prevent="toggleLoginModal()">
            <i class="bx bx-log-in-circle mr-1"/>
            <p>Login</p>
          </a>
        </li>
        <drop-down
          v-if="accessToken"  
          tag="li" 
          title="My Accounts" 
          icon="bx bx-user-circle mr-1" 
          class="nav-item">
          <nav-link 
            class="dropdown-item" 
            to="/history">
            <i class="bx bx-history"/> My Reservations
          </nav-link>
          <nav-link 
            class="dropdown-item" 
            to="/settings">
            <i class="bx bx-cog"/> Settings
          </nav-link>
          <a 
            class="dropdown-item" 
            href="#"
            @click.prevent="logout">
            <i class="bx bx-log-out-circle"/> Logout
          </a>
        </drop-down>
      </template>
    </navbar>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import { DropDown, FormGroupInput, NavbarToggleButton, Navbar, NavLink } from '@/components';

  export default {
    components: {
      DropDown,
      [FormGroupInput.name]: FormGroupInput,
      Navbar,
      NavbarToggleButton,
      NavLink
    },
    data() {
      return {
        fontSize: 'inherit',
        showReserve: false,
        directReserveList: [
          '/history',
          '/settings',
          '/faq',
          '/privacy-policy',
          '/terms-of-service'
        ]
      }
    },
    computed: {
      ...mapState([
        'accessToken',
        'options'
      ])
    },
    watch: {
      $route(to, from) {         
        if (this.directReserveList.includes(to.name)) {
          this.showReserve = true;
        } else {
          this.showReserve = false;
        }
      }
    },
    mounted() {
      const logo = document.getElementById('logoText');
      const width = logo.clientWidth;
      const fontSize = parseFloat(window.getComputedStyle(logo, null).getPropertyValue('font-size')); 
      if (window.innerWidth < 768) {
        this.fontSize = window.innerWidth - 148 > width ? 'inherit' : (window.innerWidth - 148) / width * fontSize + 'px';
      } else {
        this.fontSize = 'inherit';
      }
      window.addEventListener('resize', () => {
        if (window.innerWidth < 768) {
          this.fontSize = window.innerWidth - 148 > width ? 'inherit' : (window.innerWidth - 148) / width * fontSize + 'px';
        } else {
          this.fontSize = 'inherit';
        }
      })
    },
    methods: {
      ...mapMutations([
        'setAccessToken',
        'setMember',
        'setLoginModal'
      ]),
      toggleLoginModal() {
        this.$refs.navbar.toggle();
        this.setLoginModal(true);
      },
      logout() {
        localStorage.clear();
        this.setAccessToken(null);
        this.setMember({});
        const redirect = ['/history', '/settings'].includes(this.$route.name);
        if (redirect) {
          this.$router.push('/');
        }
      }
    }
  }
</script>

<style scoped lang='scss'>
  .navbar-brand {
    display: flex;
    align-items: center;
    color: #555357 !important;
    font-weight: 700;
    font-family: 'Montserrat';
    font-size: 1.25em !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  ::v-deep .nav-link,
  ::v-deep .dropdown-item {
    i {
      position: relative;
      top: 4px;
      font-size: 20px;
    }
  }
</style>
